import crypto from 'crypto';
import { store } from '@store';

const LANGUAGE_KEY = 'lng';
const ACCOUNT_ID_KEY = 'account';

export const setLanguageLocalStorage = (lng: string): void => {
  localStorage.setItem(LANGUAGE_KEY, lng);
};

export const getLanguage = (): string | null => {
  return localStorage.getItem(LANGUAGE_KEY);
};
export const accountIdKey = (key: string, email?: string): string =>
  crypto
    .createHash('sha1')
    .update(key + (email || store.getState().authentication.user?.email))
    .digest('hex');

export const setAccountId = (accountId: string): void => {
  localStorage.setItem(accountIdKey(ACCOUNT_ID_KEY), accountId);
};

export const getAccountId = (email?: string): string | null => {
  return localStorage.getItem(accountIdKey(ACCOUNT_ID_KEY, email));
};
